import { render, staticRenderFns } from "./ModalOdfPromo.vue?vue&type=template&id=3a35e993"
import script from "./ModalOdfPromo.vue?vue&type=script&lang=js"
export * from "./ModalOdfPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_073241/resources/assets/marketplace/components/BaseLink.vue').default})
